import React from "react";
//import I18n from "i18n-js/index.js.erb"
class RoomSelect extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.initSelect2();
  }

  componentDidUpdate(prevProps) {
    if (this.props.room == null && prevProps.room != null && this.refs.room) {
      // reset the select
      $(this.refs.room).val("").trigger("change");
    }
  }

  initSelect2() {
    var self = this;
    if (this.refs.room) {
      $(this.refs.room)
        .select2({
          ajax: {
            url: "/admin/rooms_remote",
            dataType: "json",
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                page: params.page,
                results_per_page: 40,
                include_room_groups: true,
                start_date: self.props.scheduled_at
                  ? self.props.scheduled_at.toISOString()
                  : null,
                room_type_id: self.props.room_type
                  ? self.props.room_type.id
                  : "",
                housekeeping_view: self.props.housekeepingView || null,
                reservation_id: self.props.reservation_id
                  ? self.props.reservation_id
                  : null,
                source: self.props.source || null,
              };
            },
            processResults: function (data, params) {
              params.page = params.page || 1;
              return {
                results: data.items,
                pagination: {
                  more: params.page * 40 < data.total_count,
                },
              };
            },
            cache: false,
          },
          allowClear: true,
          escapeMarkup: function (markup) {
            return markup;
          },
          placeholder: I18n.t("select_ellipsis"),
          templateResult: function (room) {
            return self.renderRoomDetails(room);
          },
          templateSelection: function (room) {
            if (room && room.id != null && room.id != "") {
              room.header = self.props.name;
              self.props.onChange(
                room,
                room.housekeeper_name,
                room.housekeeper_id
              );
            }

            return self.renderRoomDetails(room);
          },
        })
        .on("select2:unselect", function () {
          var room = { header: self.props.name, identifier: null };
          self.props.onChange(room);
        });
    }
  }

  render() {
    return (
      <div className="room">
        <select
          className="form-control"
          ref="room"
          style={{ width: "100%", minHeight: 33 }}
        >
          {this.props.room ? (
            <option
              onChange={(room) =>
                this.props.onChange(
                  this.props.room,
                  this.props.room.housekeeper_name,
                  this.props.room.housekeeper_id
                )
              }
              value={this.props.room.id}
            >
              {this.renderRoomDetails(this.props.room)}{" "}
            </option>
          ) : null}
        </select>
        {this.renderFieldError()}
      </div>
    );
  }

  renderRoomDetails(room) {
    var self = this;
    if (room && room.id != null && room.id != "" && room.identifier) {
      if (self.props.request_services) {
        return room.occupied_by
          ? room.identifier +
              " (" +
              (room.room_type_name
                ? room.room_type_name
                : I18n.t("none").italics()) +
              ") " +
              I18n.t("occupied")
          : room.identifier +
              " (" +
              (room.room_type_name
                ? room.room_type_name
                : I18n.t("none").italics()) +
              ")" ||
              room.text +
                "(" +
                (room.room_type_name ? room.room_type_name : I18n.t("none")) +
                ")";
      } else if (this.props.foliosTables) {
        if (room.text) {
          return room.text;
        } else {
          return (
            room.identifier +
            " (" +
            (room.room_type_name
              ? room.room_type_name
              : I18n.t("none").italics()) +
            ")"
          );
        }
      } else {
        return (
          room.identifier +
          " (" +
          (room.room_type_name
            ? room.room_type_name
            : I18n.t("none").italics()) +
          "): " +
          I18n.t(room.housekeeping_status || "none") +
          ", " +
          (room.occupied_until ? I18n.t("occupied") : I18n.t("vacant")) +
          (room.housekeeper_name ? " - " + room.housekeeper_name : " ")
        );
      }
    } else {
      return room.text;
    }
  }

  renderFieldError() {
    if (this.props.hasError) {
      if (this.props.hasError.includes("has-errors")) {
        if (
          $(".room").find(
            ".select2-container--default .select2-selection--single .select2-selection__rendered"
          )[0] &&
          !$(".room")
            .find(
              ".select2-container--default .select2-selection--single .select2-selection__rendered"
            )[0]
            .className.includes("has-errors")
        ) {
          $(".room").find(
            ".select2-container--default .select2-selection--single .select2-selection__rendered"
          )[0].className += this.props.hasError;
        }
      }
      if (!this.props.hasError.includes("has-errors")) {
        if (
          $(".room").find(
            ".select2-container--default .select2-selection--single .select2-selection__rendered"
          )[0] &&
          $(".room")
            .find(
              ".select2-container--default .select2-selection--single .select2-selection__rendered"
            )[0]
            .className.includes("has-errors")
        ) {
          var select = $(".room").find(
            ".select2-container--default .select2-selection--single .select2-selection__rendered"
          )[0];
          select.className = select.className.replace(/has-errors/g, "");
        }
      }
    }
  }
}

export default RoomSelect;
